import { Suspense, useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import Callback from "./context/OAuth/Callback";
import { routes } from "./routes";
import NoSubscription from "@components/ui/NoSubscription";
import DefaultLayout from "./layouts/DefaultLayout";
import Logout from "./pages/logout";
import Login from "./pages/login";
import { Navigate } from "react-router-dom";
import SplashLoader from "./components/ui/Loaders/SplashLoader";
import { SocketProvider } from "./context/SocketContext";
import SubscribtionSuspended from "@components/ui/SubscribtionSuspended";
import { useAuthLoading, useUserData } from "./context/OAuth/AuthContext";
import MedicalViewGuard from "./routes/MedicalViewGuard";
import NetworkGuard from "@routes/NetworkGuard";
import CreatePlansGuard from "@routes/CreatePlansGuard";

const AppRoutes = () => {
  const { subscription, user, setShowCreatePlan } =
    useUserData();

  const { isAuthLoading } = useAuthLoading();
  // const [showCreatePlan, setShowCreatePlan] = useState(false);
  const bypassLayoutPaths = ["/first-forms", "/create-my-plans"];

  const ActiveRoute = ({ children, activeCheck }) => {
    if (isAuthLoading) {
      return <SplashLoader />;
    }

    if (!activeCheck) {
      return children;
    }

    if (!subscription && !isAuthLoading) {
      return children;
    }

    const { status } = subscription;

    if (status === "active" || status === "pending-cancel") {
      return children;
    }

    if (status === "cancelled") {
      return (
        <DefaultLayout>
          <SubscribtionSuspended />
        </DefaultLayout>
      );
    }

    return (
      <DefaultLayout>
        <NoSubscription />
      </DefaultLayout>
    );
  };



  return (
    <SocketProvider user={user}>
      {/* <Suspense fallback={null}> */}
      <NetworkGuard>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Routes>
                  {routes.map((route) => {
                    return (
                      <Route
                        key={route.path}
                        path={route.path}
                        element={
                          <MedicalViewGuard>
                            <CreatePlansGuard>
                              <ActiveRoute
                                activeCheck={route.activeCheck}
                                bypassLayout={bypassLayoutPaths.includes(
                                  route.path
                                )}
                              >
                                {bypassLayoutPaths.includes(route.path) ? (
                                  <route.component
                                    setShowCreatePlan={setShowCreatePlan}
                                    // setOpen={setOpen}
                                    // open={open}
                                  />
                                ) : (
                                  <DefaultLayout>
                                    <route.component />
                                  </DefaultLayout>
                                )}
                              </ActiveRoute>
                            </CreatePlansGuard>
                          </MedicalViewGuard>
                        }
                      />
                    );
                  })}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </ProtectedRoute>
            }
          />
          <Route path="/logout" element={<Logout />} />
        </Routes>
      </NetworkGuard>
      {/* </Suspense> */}
    </SocketProvider>
  );
};

export default AppRoutes;
